import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { DownArrowIcon } from '@ow/icons'
import { defaultTheme } from '@ow/theme'
import {
  StyledMenuHorizontal,
  StyledMenuContent,
  StyledMenuContentNavItem,
} from './styled/menu-horizontal'
import RenderIf from '../../render-if'
import {
  getCurrentUrl,
  setDataHighlightState,
  isCurrentUrlChildren,
} from '../utils'

const MenuHorizontal = (props) => {
  const {
    style,
    backgroundColor,
    className,
    textColor,
    menuData,
    hoverFontColor,
    onMenuSelect,
    rightComponent,
    leftComponent,
    secondNav,
    renderNavLevel,
    children,
  } = props

  const [_menuData, setMenuData] = useState(menuData)
  const [secondNavData, setSecondNavData] = useState({})
  const [isRenderAllLevel] = useState(renderNavLevel === 2)

  useEffect(() => {
    for (let i = 0; i < menuData.length; i++) {
      const navs = menuData[i]
      if (isCurrentUrlChildren({ navChild: navs })) {
        setSecondNavData(navs || {})
        break
      } else setSecondNavData({})
    }

    const data = setDataHighlightState(menuData, isRenderAllLevel)
    setMenuData(data)
  }, [menuData])

  const getChildrenIsHover = (nav, navIdx, index) => {
    nav.isHover = index === navIdx
    return nav
  }
  // 鼠标悬浮到一级导航时
  const handleChildrenToOpen = (index) => {
    if (!isRenderAllLevel) return
    let arr = []
    arr = _menuData.map((nav, navIdx) => getChildrenIsHover(nav, navIdx, index))
    setMenuData(arr)
  }

  const setOpenToFalse = (nav, navIdx, index) => {
    if (navIdx === index) nav.isHover = false
    return nav
  }
  // 鼠标离开以及导航时
  const handleChildrenToClose = (index) => {
    if (!isRenderAllLevel) return
    let arr = []
    arr =
      _menuData &&
      _menuData.map((nav, navIdx) => setOpenToFalse(nav, navIdx, index))
    setMenuData(arr)
  }

  const handleParentClick = (navParent) => {
    console.log('menudata', navParent)
    // 处理父级菜单点击事件
    if (!navParent.children || !isRenderAllLevel) {
      console.log('menudata渲染了')
      console.log(
        'menudata',
        navParent.children,
        navParent.showChildren,
        navParent || {}
      )
      onMenuSelect(navParent)
      setSecondNavData(navParent || {})
    }
  }

  const handleChildrenClick = (navChild) => {
    // 处理子级菜单点击事件
    onMenuSelect(navChild)
    setSecondNavData(navChild || {})
  }

  // 渲染副导航
  const renderSecondNav = () => {
    return typeof secondNav === 'function'
      ? secondNav(secondNavData)
      : secondNav
  }

  return (
    <div
      className={children ? 'h-full flex-1 flex flex-col overflow-hidden' : ''}
      data-spec="ow-h-menu"
    >
      <StyledMenuHorizontal
        style={style}
        backgroundColor={backgroundColor}
        className={clsx([className, 'ow-primary-color', 'flex'])}
      >
        {/* 企业信息 */}
        {leftComponent}

        {/* 中间导航部分 */}
        <StyledMenuContent>
          <RenderIf isTrue={_menuData}>
            {_menuData.map((nav, index) => {
              return (
                nav.show && (
                  <StyledMenuContentNavItem
                    key={nav.url}
                    theme={defaultTheme}
                    hoverFontColor={hoverFontColor}
                    textColor={textColor}
                    className="ow-text-inverse-color"
                    onMouseOver={() => handleChildrenToOpen(index)}
                    onMouseOut={() => {
                      handleChildrenToClose(index)
                    }}
                  >
                    {/* 一级菜单 icon+name */}
                    <div
                      className={clsx({
                        'hover:text-primary': !(
                          nav.isActive || getCurrentUrl().includes(nav.matchUrl)
                        ),
                        'menu-first-level': true,
                        'menu-horizontal-nav-item-active':
                          nav.isActive ||
                          getCurrentUrl().includes(nav.matchUrl),
                      })}
                      onClick={() => {
                        handleParentClick(nav)
                      }}
                    >
                      <p
                        className={clsx({
                          'menu-first-level-name': true,
                        })}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: nav.name }}
                      />
                      <RenderIf isTrue={nav.children && isRenderAllLevel}>
                        <DownArrowIcon width={10} height={10} fill="#a6b4c6" />
                      </RenderIf>
                    </div>

                    {/* 对应children部分 */}
                    <RenderIf isTrue={nav.children}>
                      <div
                        style={{
                          opacity: nav.isHover ? '1' : '0',
                          marginTop: nav.isHover ? '0' : '6px',
                          visibility: nav.isHover ? 'visible' : 'hidden',
                        }}
                        className="menu-children-level"
                      >
                        {nav.children &&
                          nav.children.map((navChild) => {
                            return (
                              <div
                                key={navChild.url}
                                className={`${
                                  getCurrentUrl().includes(navChild.matchUrl) ||
                                  navChild.isActive
                                    ? 'menu-horizontal-nav-child-item-active'
                                    : 'menu-horizontal-nav-child-item-normal'
                                } menu-child-level-name hover:text-primary text-secondary-900`}
                                onClick={() => {
                                  handleChildrenClick(navChild)
                                }}
                              >
                                {navChild.name}
                              </div>
                            )
                          })}
                      </div>
                    </RenderIf>
                  </StyledMenuContentNavItem>
                )
              )
            })}
          </RenderIf>
        </StyledMenuContent>

        {/* 用户信息 */}
        {rightComponent}
      </StyledMenuHorizontal>
      {console.log('menudata-horizontal', children)}
      {console.log('menudata-horizontal', secondNav)}
      {console.log(
        'menudata-horizontal',
        secondNavData.children,
        secondNavData.showChildren
      )}
      <RenderIf
        isTrue={
          children &&
          secondNav &&
          secondNavData.children &&
          secondNavData.children.length &&
          secondNavData.showChildren
        }
      >
        <div
          className="flex overflow-y-auto"
          style={{ height: 'calc(100% - 58px)' }}
        >
          {renderSecondNav()}
          {children}
        </div>
      </RenderIf>
      <RenderIf isTrue={!secondNavData.children || !secondNavData.showChildren}>
        {children}
      </RenderIf>
    </div>
  )
}

// 默认参数
MenuHorizontal.defaultProps = {
  style: {},
  backgroundColor: undefined,
  className: undefined,
  textColor: undefined,
  // menuData: [],
  hoverFontColor: undefined,
  onMenuSelect: undefined,
  rightComponent: undefined,
  leftComponent: undefined,
  secondNav: undefined,
  children: undefined,
  renderNavLevel: 2,
}

// 参数类型
MenuHorizontal.propTypes = {
  style: PropTypes.shape({}),
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  textColor: PropTypes.string,
  // menuData: PropTypes.arrayOf(PropTypes.object),
  hoverFontColor: PropTypes.string,
  onMenuSelect: PropTypes.func,
  rightComponent: PropTypes.node,
  leftComponent: PropTypes.node,
  secondNav: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  children: PropTypes.node,
  renderNavLevel: PropTypes.oneOf([1, 2]),
}

export default MenuHorizontal
